import React, { useEffect, useState, useRef } from 'react';
import api from "~/services/api";
import { Container, ContainerComm, ContainerTable, StyledTable, ThisProgress, ThisTr } from './styles';
import { SLTableCell } from "~/pages/Sistema/componentes/SistemaList";
import GaugeChart from 'react-gauge-chart';
import { Colors } from "~/config/Colors";
import { Materialize } from "~/styles/materializeGrid";

import IconInsatisfeito from '~/assets/icones/icon_insatisfeito.png';
import IconMuitoInsatisfeito from '~/assets/icones/icon_muito_insatisfeito.png';
import IconSatisfeito from '~/assets/icones/icon_satisfeito.png';
import IconMuitosatisfeito from '~/assets/icones/icon_muito_satisfeito.png';
import IconNormal from '~/assets/icones/icon_muito_normal.png';
import Logo from '~/assets/logos/Logo ManyFlows Vertical.png';
import TableComponent from '../TableComponent';

function PainelPDF({ data }) {
  const [loadedDataComm, setLoadedDataComm] = useState(false);
  const [dataPdf, setDataPdf] = useState([]);
  const cores = [
    "#2E7AD3",
    "#FF5780",
    "#802ED3",
    "#C62ED3",
    "#CAC4C8",
    "#CE6D14",
    "#D32EA5",
    "#14ADCE",
    "#4691C7",
    "#FF9090",
    "#D4F37B",
    "#FFF27E",
    "#4F4F4F",
    "#B9FFDE",
    "#B9D1FF",
  ];

  return (
    <Container>
      <div className="barra-sup"></div>
      <div className="header">
        <img src={Logo} alt="Logo" />
        <div class="text">
          <p class="titulo">Gestor Serviço</p>
          <p class="titulo-relatorio">Relatório do Dashboard</p>
          <p class="titulo-data">Relatório gerado em {new Date().toLocaleString()}</p>
        </div>
      </div>
      <div className="body">
        <div className="mid">
          <div className="col">
            <div className="linha">
              <p className="titulo">Pesquisa:</p>
              <p className="valor">{data?.tituloPesquisa}</p>
            </div>
            <div className="linha">
              <p className="titulo">Período:</p>
              <p className="valor">{data?.tituloPeriodo}</p>
            </div>
          </div>
          <div className="col rigth">
            <div className="linha">
              <p className="titulo">Turnos:</p>
              <p className="valor">{data?.tituloTurno}</p>
            </div>
            <div className="linha">
              <p className="titulo">Centro de Custo:</p>
              <p className="valor">{data?.listaCCs}</p>
            </div>
          </div>
        </div>
      </div>
    </Container >
  );
};

export default PainelPDF;